import React from "react";
import { validateProperty } from "../../common/validate";

import { Input } from "../../common/Input";

const SenderInformation = ({
  data,
  setData,
  errors,
  setErrors,
  submitOnce
}) => {
  const handleChange = ({ currentTarget: input }) => {
    if (submitOnce) {
      const newErrors = { ...errors };
      const errorMessage = validateProperty(input, "billing_address");
      if (errorMessage) newErrors[input.name] = errorMessage;
      else delete newErrors[input.name];
      setErrors(newErrors);
    }

    setData({
      ...data,
      [input.name]: input.value
    });
  };

  return (
    <>
      <div className="row mb-3">
        <h2>Sender Information</h2>
      </div>
      <div className="row mb-md mb-md-mobile-off">
        <div className="col-12 col-md-6">
          <Input
            label="NAME(S)"
            name="card_name"
            data={data}
            errors={errors}
            type="text"
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="STREET ADDRESS"
            name="street_address"
            data={data}
            errors={errors}
            type="text"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mb-md mb-md-mobile-off">
        <div className="col-12 col-md-6">
          <Input
            label="CITY"
            name="city"
            data={data}
            errors={errors}
            type="text"
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="PROVINCE/STATE"
            name="state"
            data={data}
            errors={errors}
            type="text"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mb-lg">
        <div className="col-12 col-md-6">
          <Input
            label="POSTAL/ZIP CODE"
            name="zip_code"
            data={data}
            errors={errors}
            type="text"
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="COUNTRY"
            name="country"
            data={data}
            errors={errors}
            type="text"
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};

export default SenderInformation;
